/** InsCoder WANG.J 2024-04-02 B + Move special tips to gai container **/
(function() {
  let cachedTipsText = "";

  function getTipsText() {
    if (cachedTipsText) return cachedTipsText;
    const sourceTipsElement = document.querySelector('.you-may-also-like-special-tips');
    if (sourceTipsElement && sourceTipsElement.textContent.trim()) {
      cachedTipsText = sourceTipsElement.textContent.trim();
      return cachedTipsText;
    }
    return "";
  }

  function hideOriginalTips() {
    document.querySelectorAll('.you-may-also-like-special-tips').forEach(el => {
      if (el.style.display !== 'none') {
        el.style.display = 'none';
      }
    });
  }

  function renderTips() {
    // Listen for .Cart-Drawer.show specifically as requested
    const cartDrawer = document.querySelector('.Cart-Drawer.show') || document.querySelector('.Cart-Drawer');
    if (!cartDrawer) return;

    const gaiContainer = cartDrawer.querySelector('._gai-container');
    if (!gaiContainer) return;

    // Get the first _gai-grid-item
    const firstGridItem = gaiContainer.querySelector('._gai-grid-item');
    if (!firstGridItem) return;

    // Get the _gai-prod-tit element inside the first grid item
    const targetElement = firstGridItem.querySelector('._gai-prod-tit');
    if (!targetElement) return;

    // Prevent duplicate rendering
    if (firstGridItem.querySelector('.gai-special-tips-rendered')) return;

    const tipsText = getTipsText();
    if (!tipsText) return;

    // Hide original element now that we're about to render it
    hideOriginalTips();

    const tipsNode = document.createElement('div');
    tipsNode.className = 'gai-special-tips-rendered';
    tipsNode.textContent = tipsText;
    
    // // Base styling
    // tipsNode.style.fontSize = '12px';
    // tipsNode.style.color = '#595c61';
    // tipsNode.style.marginBottom = '8px';
    // tipsNode.style.fontWeight = '500';

    // Insert right above the _gai-prod-tit element
    targetElement.parentNode.insertBefore(tipsNode, targetElement);
  }

  function init() {
    getTipsText();

    // 1. Observe document.body instead of Cart-Drawer.
    // This is crucial because Shopify AJAX carts often replace the entire Cart-Drawer DOM element
    // when updated, which would instantly kill an observer attached directly to it.
    const observer = new MutationObserver(() => {
      renderTips();
    });

    observer.observe(document.body, { 
      childList: true, 
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    // 2. Polling fallback (runs every 500ms) to guarantee execution
    // even if the third-party app uses a delayed render or skips typical mutation events.
    setInterval(renderTips, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/** InsCoder WANG.J 2024-04-02 E + Move special tips to gai container **/